export default "__VITE_ASSET__pR24hJKK__ 288w, __VITE_ASSET__Dsw6QztV__ 432w, __VITE_ASSET__D2GyccG6__ 576w";